import { create } from 'zustand';

import { JobPositionFeatureDomain } from '@pflegia/types/common/enums/job-position-feature-domain.enum';

type SpecificFeatureDomain = JobPositionFeatureDomain.JobBoard | JobPositionFeatureDomain.JobListings;

export type FeatureByJobPositionId = {
  [jobPositionId: string]:
    | undefined
    | {
        hasFastResponse: boolean;
        hasTopSalary: boolean;
        isNewChance: boolean;
      };
};

type StoreState = {
  [key in SpecificFeatureDomain]: FeatureByJobPositionId;
};

type StoreCallbacks = {
  set: (domain: SpecificFeatureDomain, updates: FeatureByJobPositionId) => void;
};

const DEFAULT_STATE: StoreState = {
  [JobPositionFeatureDomain.JobBoard]: {},
  [JobPositionFeatureDomain.JobListings]: {},
};

export const useJobPositionsFeaturesStore = create<StoreState & StoreCallbacks>(set => ({
  ...DEFAULT_STATE,
  set: (domain, updates) =>
    set(state => ({
      ...state,
      [domain]: { ...state[domain], ...updates },
    })),
}));
